<template>
  <v-container>
    <v-data-table
      :headers="headers"
      :items="districts"
      class="elevation-1"
      :loading="loading"
      :items-per-page="-1"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Městské části</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-spacer>Výpis</v-spacer>
          <v-dialog
            v-model="dialog"
            max-width="650"
          >
          <template
            v-slot:activator="{ on, attrs }"
          >
            <v-btn
              @click="editedItem = defaultItem"
              color="primary"
              v-bind="attrs"
              v-on="on"
            >
              Přidat část
            </v-btn>
          </template>
          <DistrictsForm
            :item="editedItem"
            v-if="dialog"
            @data-saved="getDistricts"
          >
          </DistrictsForm>
        </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editDistrict(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          small
          class="mr-2"
          @click="toggleActive(item)"
        >
          {{item.active ? 'mdi-sleep' : 'mdi-sleep-off'}}
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="getDistricts">Reset</v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import DistrictsForm from '../../forms/admin/DistrictsForm'
export default {
  name: 'Districts',
  components: { DistrictsForm },
  data () {
    return {
      loading: true,
      dialog: false,
      editedItem: {},
      defaultItem: {
        id: null,
        name: null,
        active: false,
        deliveryPrice: ''
      },
      headers: [
        { text: 'Název', value: 'name' },
        { text: 'Cena rozvozu', value: 'deliveryPrice' },
        { text: 'Aktivní', value: 'activeStr' },
        { text: 'Akce', value: 'actions' }
      ],
      districts: []
    }
  },
  methods: {
    getDistricts () {
      this.loading = true
      this.dialog = false
      this.$http.get('/admin/city-districts')
        .then(response => {
          this.districts = this.keysToCamelCase(response.data).map(district => {
            district.activeStr = district.active ? 'Aktivní' : 'Deaktivováno'
            return district
          })
          this.loading = false
        })
        .catch(err => console.log(err))
    },
    editDistrict (district) {
      this.editedItem = Object.assign({}, district)
      this.dialog = true
    },
    toggleActive (district) {
      district.active = !district.active
      this.$http.delete(`/admin/city-districts/${district.id}`, this.keysToSnakeCase(district))
        .then(() => {
          this.getDistricts()
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  created () {
    this.getDistricts()
  }
}
</script>

<style scoped>

</style>
